/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * Label type enumeration.
 */
export type LabelKind = typeof LabelKind[keyof typeof LabelKind];


export const LabelKind = {
  premiere: 'premiere',
  fresh: 'fresh',
  abandoned: 'abandoned',
  exclusive: 'exclusive',
  top: 'top',
} as const;
